export default __webpack_public_path__ + "static/progress-bar-data-viz-dont-dbde23eaef443e34f1554406255102ca42f6a68085064d09355b7096b335abb0.png";